import React from 'react';

import useBranch from 'client/hooks/useBranch';

import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';
import './SrPartnerRedirectionBanner.less';

const SrPartnerRedirectionBanner = () => {
  const {
    currentPartner,
  } = useBranch({
    currentPartner: ['partners', 'currentPartner'],
  });

  if (!currentPartner) {
    return null;
  }

  return (
    <div className='SrPartnerRedirectionBanner' styleName='component'>
      <SrLink
        to={`/partner/${currentPartner.slug}`}
        styleName='link'
      >
        <div styleName='content'>
          <SrText font='greycliff' weight='800' color='white'>
            You're viewing the renter website.
          </SrText>
          {' '}
          <SrText font='greycliff' weight='800' color='blue400' styleName='arrow'>
            Tap here to go to the partner portal
          </SrText>
        </div>
      </SrLink>
    </div>
  );
};

SrPartnerRedirectionBanner.displayName = 'SrPartnerRedirectionBanner';

export default SrPartnerRedirectionBanner;
